import { render } from "./LastConversations.vue?vue&type=template&id=51760d90&scoped=true"
import script from "./LastConversations.vue?vue&type=script&lang=js"
export * from "./LastConversations.vue?vue&type=script&lang=js"

import "./LastConversations.vue?vue&type=style&index=0&id=51760d90&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51760d90"]])

export default __exports__